import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const loadBankSettings = createAsyncThunk(
    'bankSettings/loadBankSettings',
    async ({bankId, token}) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/user/bank/${bankId}`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const updateBankSettings = createAsyncThunk(
    'bankSettings/updateBankSettings',
    async ({newBankSettings, token}) => {
        const requestBody = JSON.stringify(newBankSettings);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/bank/update`,
            {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const bankSettingsSlice = createSlice({
    name: 'bankSettings',
    initialState: {
        bankSettings: {},
        editMode: false,
        loadingBankSettings: false,
        failedToLoadBankSettings: false,
        confirmingBankUpdate: false,
        updatingBankSettings: false,
        failedToUpdateBankSettings: false
    },
    reducers: {
        toggleEditMode: (state) => {
            return {
                ...state,
                editMode: !state.editMode
            }
        },
        changeBankSettings: (state, action) => {
            return {
                ...state,
                bankSettings: action.payload
            }
        },
        changeBankName: (state, action) => {
            return {
                ...state,
                bankSettings: {
                    ...state.bankSettings,
                    bankName: action.payload
                }
            }
        },
        toggleCheckingActive: (state, action) => {
            return {
                ...state,
                bankSettings: {
                    ...state.bankSettings,
                    checkingActive: action.payload
                }
            }
        },
        toggleSavingsActive: (state, action) => {
            return {
                ...state,
                bankSettings: {
                    ...state.bankSettings,
                    savingsActive: action.payload
                }
            }
        },
        changeSavingsRate: (state, action) => {
            return {
                ...state,
                bankSettings: {
                    ...state.bankSettings,
                    savingsRate: action.payload
                }
            }
        },
        changeTellerDepositPermission: (state, action) => {
            return {
                ...state,
                bankSettings: {
                    ...state.bankSettings,
                    tellerDepositPermission: action.payload
                }
            }
        },
        changeTellerWithdrawalPermission: (state, action) => {
            return {
                ...state,
                bankSettings: {
                    ...state.bankSettings,
                    tellerWithdrawalPermission: action.payload
                }
            }
        },
        changeTellerTransferPermission: (state, action) => {
            return {
                ...state,
                bankSettings: {
                    ...state.bankSettings,
                    tellerTransferPermission: action.payload
                }
            }
        },
        changeConfirmingBankUpdate: (state, action) => {
            return {
                ...state,
                confirmingBankUpdate: action.payload
            }
        },
        clearBankSettings: (state) => {
            return {
                ...state,
                bankSettings: {}
            }
        }
    },
    extraReducers: {
        [loadBankSettings.pending]: (state) => {
            return {
                ...state,
                loadingBankSettings: true,
                failedToLoadBankSettings: false
            }
        },
        [loadBankSettings.fulfilled]: (state, action) => {
            return {
                ...state,
                loadingBankSettings: false,
                failedToLoadBankSettings: false,
                bankSettings: action.payload
            }
        },
        [loadBankSettings.rejected]: (state) => {
            return {
                ...state,
                loadingBankSettings: false,
                failedToLoadBankSettings: true
            }
        },
        [updateBankSettings.pending]: (state) => {
            return {
                ...state,
                updatingBankSettings: true,
                failedToUpdateBankSettings: false
            }
        },
        [updateBankSettings.fulfilled]: (state, action) => {
            return {
                ...state,
                bankSettings: action.payload,
                updatingBankSettings: false,
                failedToUpdateBankSettings: false
            }
        },
        [updateBankSettings.rejected]: (state) => {
            return {
                ...state,
                updatingBankSettings: false,
                failedToUpdateBankSettings: true
            }
        }
    }
})

export const selectBankSettings = (state) => state.bankSettings.bankSettings;
export const bankSettingsLoading = (state) => state.bankSettings.loadingBankSettings;
export const editModeActive = (state) => state.bankSettings.editMode;
export const selectConfirmingBankUpdate = (state) => state.bankSettings.confirmingBankUpdate;

export const { 
    changeTellerDepositPermission, 
    changeTellerWithdrawalPermission, 
    changeTellerTransferPermission, 
    toggleEditMode, 
    changeBankName, 
    toggleCheckingActive, 
    toggleSavingsActive, 
    changeSavingsRate, 
    changeConfirmingBankUpdate,
    clearBankSettings,
    changeBankSettings 
} = bankSettingsSlice.actions;

export default bankSettingsSlice.reducer;